module.exports = __webpack_public_path__ + "static/media/spegle.cf334b3c.m4a";